












































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import {
  UnitDevicePointData, emptyPoint, getPointTypes
} from '@/api/heritageUnit/unitDevice'
import { getLookupByType, DDLItem } from '@/api/common/select'
import { enFirstType, enLookupType } from '@/configs/enums'
import { getDDLItem } from '@/configs/functions'
import { validateIntKey, showVaildMsg } from '@/configs/validate'
import Element from 'element-ui'
import FormDialog from '@/components/dialog/formDialog.vue'

const getFormRules = (form: { [key: string]: string }) => {
  return {
    PointName: [{ required: true, message: '请输入测点名', trigger: 'blur' }],
    PointType: [{ required: true, message: '请选择偏移量类型', trigger: 'change' }],
    PointNum: [{ type: 'number', message: '必须为数字', trigger: 'blur' }],
    PointValueUnit: [{ required: true, validator: validateIntKey('请选择数据单位'), trigger: 'change' }],
    PointValueType: [{ required: true, validator: validateIntKey('请选择数据类型'), trigger: 'change' }],
    ScopeValueHigh: [{ type: 'number', message: '必须为数字', trigger: 'blur' }],
    ScopeValueLow: [{ type: 'number', message: '必须为数字', trigger: 'blur' }]
  }
}
@Component({
  components: {
    FormDialog
  }
})
export default class DevicePointForm extends Vue {
  public name = 'DevicePointForm'
  public expandNames = ['info']
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false
  public refTarget: string = ''
  public typeList: DDLItem[] = []
  public valueTypeList: DDLItem[] = []
  public valueUnitList: DDLItem[] = []
  public form = Object.assign({}, emptyPoint)
  public rules = getFormRules(this.form)

  public $refs!: {
    formData: Element.Form
  }
  public created() { }
  public fetchSource() {
    if (this.valueTypeList.length == 0) {
      getLookupByType(
        enLookupType.DevicePointValueType,
        enFirstType.Select
      ).then((response: { data: any }) => {
        this.valueTypeList = response.data
      })
    }
    if (this.valueUnitList.length == 0) {
      getLookupByType(
        enLookupType.DevicePointValueUnit,
        enFirstType.Select
      ).then((response: { data: any }) => {
        this.valueUnitList = response.data
      })
    }
    if (this.typeList.length == 0) {
      getPointTypes(enFirstType.Select).then((response: { data: any }) => {
        this.typeList = response.data
      })
    }
  }
  public mounted() {
    window.eventBus.$on('openDevicePointForm', (info: any) => {
      this.refTarget = info.targetId
      this.fetchSource()
      this.modifyData(info.data)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('openDevicePointForm')
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public newData(seq: number) {
    var newForm = Object.assign({}, emptyPoint)
    newForm.SubSequence = seq
    this.modifyData(newForm)
  }
  public modifyData(info: UnitDevicePointData) {
    this.open()
    this.form = Object.assign({}, info)
  }
  public sendData(info: UnitDevicePointData) {
    window.eventBus.$emit('submitDevicePointForm', {
      targetId: this.refTarget,
      data: info
    })
  }
  public onSubmit() {
    let f = Object.assign({}, this.form)
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        // var f = Object.assign({}, this.form)
        var item = getDDLItem(this.valueTypeList, f.PointValueType)
        if (item.Key > 0) {
          f.ValueTypeName = item.Val
        }
        var item1 = getDDLItem(this.valueUnitList, f.PointValueUnit)
        if (item1.Key > 0) {
          f.ValueUnitName = item1.Val
        }
        this.sendData(f)
        this.close()
      } else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}
